import * as http from 'node:http';
import { closeHttpServer } from '../../http/close-http-server.js';
import type { BridgeMcpToolRegistry } from '../bridge-mcp-tool-types.js';
import { createBridgeAccessRequestHandler } from './handle-request.js';
import type { BridgeAccessServerHandle } from './types.js';

/**
 * Loopback HTTP bridge access server: the CLI bridge uses this to serve tool list/call requests
 * from the stdio MCP subprocess spawned for ACP agents.
 */
export function startBridgeAccessServer(registry: BridgeMcpToolRegistry): Promise<BridgeAccessServerHandle> {
  const server = http.createServer(createBridgeAccessRequestHandler(registry));

  return new Promise((resolve, reject) => {
    server.once('error', reject);
    server.listen(0, '127.0.0.1', () => {
      const addr = server.address();
      if (!addr || typeof addr === 'string') {
        reject(new Error('Bridge access server did not bind'));
        return;
      }
      resolve({
        port: addr.port,
        close: () => closeHttpServer(server),
      });
    });
  });
}
